<template>
  <v-main class="page-form-main-form">
    <portal to="app-bar">
      <v-app-bar
        app
        color="secondary"
        dark
      >
        <v-toolbar-title>{{ project ? project.name : $t('form.show.main-form') }}</v-toolbar-title>
      </v-app-bar>
    </portal>

    <v-container v-if="form">
      <FormComponent
        v-model="internalFormData"
        :form="form"
        type="main"
        doc-id=""
        @submit="saved"
      />
    </v-container>
  </v-main>
</template>

<script>
import FormComponent from '@/components/FormComponent';
import axios from 'axios';

export default {
  components: {
    FormComponent
  },
  data: () => ({
    http: null,
    project: null,
    internalFormData: [],
    form: null
  }),
  mounted () {
    this.form = window.form;
  },
  methods: {
    async saved(value) {
      const loader = this.$loading.show();

      if (window.submitForm) {
        try {
          for (const key in value) {
            if (value[key] && (value[key] instanceof File || (value[key].blob && value[key].blob instanceof Blob))) {
              const file = value[key];
              let blob;
              if (!file.blob) {
                blob = new Blob([await file.arrayBuffer()], { type: file.type });
              } else {
                blob = file.blob;
              }

              // TODO: direct file upload
              if (file.blob) {
                value[key] = {
                  fieldType: 'file',
                  name: file.name,
                  size: file.blob.size,
                  type: file.blob.type
                };
              } else {
                value[key] = {
                  fieldType: 'file',
                  name: file.name,
                  size: file.size,
                  type: file.type
                };
              }
            }
          }

          window.submitForm(value);
          window.close();
        } catch (e) {
          console.error(e);
          alert('ERROR');
        }
      } else {
        window.close();
      }
    }
  }
};
</script>
